export const TRANSACTION_START = "transaction/start";
export const TRANSACTION_FINISH = "transaction/finish";
export const TRANSACTION_ADD_TO_QUEUE = "transaction/addToQueue";
export const TRANSACTION_REMOVE_FROM_QUEUE = "transaction/removeFromQueue";

// !!!! Tried implementing and referencing the typeHelpers.ActionsType, however this caused typescript to fail silently
// These properties are dynamically configured on an action, hence are all optional
export type OrigActionType = TransactionBaseType & { _snapshot: any; type: any };
// TODO Find a better name for this
export type TransactionInternalActionType = {
    action: string;
    actionQueue: { type: string; actionId?: string }[];
};

export type TransactionBaseType = {
    // Type can be string see TRANSACTION_START logic, however when executing a new action you pass it as a boolean
    transaction?: string | boolean;
    actionId?: string;
    origAction?: OrigActionType;
    transactionAction?: TransactionInternalActionType;
};

export type StartTransactionType = TransactionBaseType & {
    type: typeof TRANSACTION_START;
    origAction: OrigActionType;
};

export type FinishTransactionType = TransactionBaseType & {
    type: typeof TRANSACTION_FINISH;
    transactionId?: string;
};

export type AddToQueueType = TransactionBaseType & {
    type: typeof TRANSACTION_ADD_TO_QUEUE;
    transaction: string;
    origAction: OrigActionType;
};

export type RemoveFromQueueType = TransactionBaseType & {
    type: typeof TRANSACTION_REMOVE_FROM_QUEUE;
    origAction: OrigActionType;
};

export const startTransaction = (origAction: OrigActionType): StartTransactionType => ({
    type: TRANSACTION_START,
    origAction,
});
export const finishTransaction = (transactionId: string = ""): FinishTransactionType => ({
    type: TRANSACTION_FINISH,
    transactionId,
});

export const addToQueue = (transaction: string, origAction: OrigActionType): AddToQueueType => ({
    type: TRANSACTION_ADD_TO_QUEUE,
    transaction,
    origAction,
});
export const removeFromQueue = (origAction: OrigActionType): RemoveFromQueueType => ({
    type: TRANSACTION_REMOVE_FROM_QUEUE,
    origAction,
});

export type TransactionActionType = StartTransactionType | FinishTransactionType | AddToQueueType | RemoveFromQueueType;
